export const module19InitialState = {
  module19: {
    stepCompleted: 'notstarted',
sectionCompleted: 0,
    StudentID: '',
    moduleID: '',
    keys: 0,
    coins: 0,
    learnIcon: false,
    practiceIcon: false,
    celebrateIcon: false,
    reviewIcon: false,
    cameraIcon: false,
    singingIcon: false,
    currentday: 1,
    cameraOpen: false,
    userRecordedVideos: false,
    game_details: {},
    day_completed: 0,
    rewards: {
      Hat: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      Bowtie: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      Binoculars: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      Camera: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      JeepPink: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      JeepBlue: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      Parrot: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      Tucan: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      TrainOrange: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      TrainGreen: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      MonkeyCapuchin: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      MonkeyGorilla: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      SnakeOrange: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      SnakeGreen: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      StandIceCreamBlue: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      StandIceCreamGreen: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      MonkeySafari: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      MonkeySunglasses: {
        unlocked: false,
        x: 0,
        y: 0,
      },
    },
    unlockedDays: {
      day1: true,
      day2: false,
      day3: false,
      day4: false,
      day5: false,
      day6: false,
      day7: false,
      day8: false,
    },
  },
};

export const Module19Reducer = (state = module19InitialState, action) => {
  switch (action.type) {
    case 'SET_MODULE19_INITIALSTATE': {
      let step = 'notstarted';
      if (action.payload?.step_completed !== null) {
        step = action.payload?.step_completed;
      }
      let day = 0;
      if (action.payload?.day_completed!== null) {
        day = action.payload?.day_completed;
      }

      // map through the object and set the rewards to true
      const tempRewards = {
        Hat: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        Bowtie: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        Binoculars: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        Camera: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        JeepPink: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        JeepBlue: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        Parrot: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        Tucan: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        TrainOrange: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        TrainGreen: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        MonkeyCapuchin: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        MonkeyGorilla: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        SnakeOrange: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        SnakeGreen: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        StandIceCreamBlue: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        StandIceCreamGreen: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        MonkeySafari: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        MonkeySunglasses: {
          unlocked: false,
          x: 0,
          y: 0,
        },
      };
      let tempObj = action.payload?.game_details;
      if (tempObj !== 'null') {
        const obj = JSON.parse(tempObj)?.dailyRewards;
        for (let i = 0; i < obj.length; i++) {
          for (let j = 0; j < Object.keys(tempRewards).length; j++) {
            if (obj[i]?.type === Object.keys(tempRewards)[j]) {
              tempRewards[Object.keys(tempRewards)[j]].unlocked = true;
              tempRewards[Object.keys(tempRewards)[j]].x = obj[i]?.x_multiplier;
              tempRewards[Object.keys(tempRewards)[j]].y = obj[i]?.y_multiplier;
            }
          }
        }
      } else {
        tempObj = '{"moduleFlags":[],"dailyRewards":[], "tokens_earned":0}';
      }

      const tempUnlockedDays = {
        day1: true,
        day2: false,
        day3: false,
        day4: false,
        day5: false,
        day6: false,
        day7: false,
        day8: false,
      };
      if (action.payload?.day_completed !== null) {
        for (let i = 1; i <= action.payload?.day_completed + 1; i++) {
          tempUnlockedDays[`day${i}`] = true;
        }
      }
      // "{\"moduleFlags\":[{\"flag\":\"InProgress\",\"lastUpdated\":\"2021-05-23T07:46:45.95Z\"},{\"flag\":\"WatchedSurprise\",\"lastUpdated\":\"2021-05-23T07:45:41.51Z\"}],\"dailyRewards\":[{\"type\":\"Hat\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"UmbrellaGreen\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"JeepPink\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"JeepPink\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"OceanWhale\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"SandBucket\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"Parrot\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"BeachwearSandles\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"StandIceCreamGreen\",\"x_multiplier\":1,\"y_multiplier\":1}]}"
      // "{\"moduleFlags\":[],\"dailyRewards\":[]}"

      return {
        ...state,
        module19: {
          ...state.module19,
          StudentID: action.payload?.student_id,
          stepCompleted: step,
          moduleID: action.payload?.id,
          unlockedDays: tempUnlockedDays,
          rewards: tempRewards,
          day_completed: day,
          game_details: JSON.parse(tempObj),
          coins: JSON.parse(tempObj)?.tokens_earned,
        },
      };
    }

    case 'CLEAR': {
      return {
        ...module19InitialState,
      };
    }
    case 'MODULE19_SET_DAY': {
      return {
        ...state,
        module19: {
          ...state.module19,
          currentday: action.payload,
        },
      };
    }

    case 'MODULE19_SET_GameDetials': {
      return {
        ...state,
        module19: {
          ...state.module19,
          game_details: action.payload,
        },
      };
    }

    case 'MODULE19_SET_stepCompleted': {
      return {
        ...state,
        module19: {
          ...state.module19,
          stepCompleted: action.payload,
        },
      };
    }

    case 'MODULE19_SET_dayCompleted': {
      return {
        ...state,
        module19: {
          ...state.module19,
          day_completed: action.payload,
        },
      };
    }

    case 'MODULE19_SET_CAMERAOPEN': {
      return {
        ...state,
        module19: {
          ...state.module19,
          cameraOpen: action.payload,
        },
      };
    }
    case 'MODULE19_SET_KEY': {
      return {
        ...state,
        module19: {
          ...state.module19,
          keys: action.payload,
        },
      };
    }
    case 'MODULE19_SET_COIN': {
      return {
        ...state,
        module19: {
          ...state.module19,
          coins: action.payload,
        },
      };
    }
    case 'MODULE19_TOGGLE_PRACTICE_ICON': {
      return {
        ...state,
        module19: {
          ...state.module19,
          practiceIcon: action.payload,
        },
      };
    }
    case 'MODULE19_TOGGLE_CAMERA_ICON': {
      return {
        ...state,
        module19: {
          ...state.module19,
          cameraIcon: action.payload,
        },
      };
    }
    case 'MODULE19_TOGGLE_SINGING_ICON': {
      return {
        ...state,
        module19: {
          ...state.module19,
          singingIcon: action.payload,
        },
      };
    }
    case 'MODULE19_TOGGLE_LEARN_ICON': {
      return {
        ...state,
        module19: {
          ...state.module19,
          learnIcon: action.payload,
        },
      };
    }
    case 'MODULE19_TOGGLE_CELEBRATE_ICON': {
      return {
        ...state,
        module19: {
          ...state.module19,
          celebrateIcon: action.payload,
        },
      };
    }
    case 'MODULE19_TOGGLE_REVIEW_ICON': {
      return {
        ...state,
        module19: {
          ...state.module19,
          reviewIcon: action.payload,
        },
      };
    }
    case 'MODULE19_SET_REWARD81': {
      return {
        ...state,
        module19: {
          ...state.module19,
          rewards: {
            ...state.module19.rewards,
            Hat: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE19_SET_REWARD81_POSITION': {
      return {
        ...state,
        module19: {
          ...state.module19,
          rewards: {
            ...state.module19.rewards,
            Hat: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE19_SET_REWARD82': {
      return {
        ...state,
        module19: {
          ...state.module19,
          rewards: {
            ...state.module19.rewards,
            Bowtie: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE19_SET_REWARD82_POSITION': {
      return {
        ...state,
        module19: {
          ...state.module19,
          rewards: {
            ...state.module19.rewards,
            Bowtie: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE19_SET_REWARD21': {
      return {
        ...state,
        module19: {
          ...state.module19,
          rewards: {
            ...state.module19.rewards,
            Binoculars: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE19_SET_REWARD21_POSITION': {
      return {
        ...state,
        module19: {
          ...state.module19,
          rewards: {
            ...state.module19.rewards,
            Binoculars: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE19_SET_REWARD22': {
      return {
        ...state,
        module19: {
          ...state.module19,
          rewards: {
            ...state.module19.rewards,
            Camera: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE19_SET_REWARD22_POSITION': {
      return {
        ...state,
        module19: {
          ...state.module19,
          rewards: {
            ...state.module19.rewards,
            Camera: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE19_SET_REWARD31': {
      return {
        ...state,
        module19: {
          ...state.module19,
          rewards: {
            ...state.module19.rewards,
            JeepPink: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE19_SET_REWARD31_POSITION': {
      return {
        ...state,
        module19: {
          ...state.module19,
          rewards: {
            ...state.module19.rewards,
            JeepPink: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE19_SET_REWARD32': {
      return {
        ...state,
        module19: {
          ...state.module19,
          rewards: {
            ...state.module19.rewards,
            JeepBlue: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE19_SET_REWARD32_POSITION': {
      return {
        ...state,
        module19: {
          ...state.module19,
          rewards: {
            ...state.module19.rewards,
            JeepBlue: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE19_SET_REWARD41': {
      return {
        ...state,
        module19: {
          ...state.module19,
          rewards: {
            ...state.module19.rewards,
            Parrot: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE19_SET_REWARD41_POSITION': {
      return {
        ...state,
        module19: {
          ...state.module19,
          rewards: {
            ...state.module19.rewards,
            Parrot: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE19_SET_REWARD42': {
      return {
        ...state,
        module19: {
          ...state.module19,
          rewards: {
            ...state.module19.rewards,
            Tucan: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE19_SET_REWARD42_POSITION': {
      return {
        ...state,
        module19: {
          ...state.module19,
          rewards: {
            ...state.module19.rewards,
            Tucan: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE19_SET_REWARD51': {
      return {
        ...state,
        module19: {
          ...state.module19,
          rewards: {
            ...state.module19.rewards,
            TrainOrange: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE19_SET_REWARD51_POSITION': {
      return {
        ...state,
        module19: {
          ...state.module19,
          rewards: {
            ...state.module19.rewards,
            TrainOrange: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE19_SET_REWARD52': {
      return {
        ...state,
        module19: {
          ...state.module19,
          rewards: {
            ...state.module19.rewards,
            TrainGreen: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE19_SET_REWARD52_POSITION': {
      return {
        ...state,
        module19: {
          ...state.module19,
          rewards: {
            ...state.module19.rewards,
            TrainGreen: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE19_SET_REWARD61': {
      return {
        ...state,
        module19: {
          ...state.module19,
          rewards: {
            ...state.module19.rewards,
            MonkeyCapuchin: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE19_SET_REWARD61_POSITION': {
      return {
        ...state,
        module19: {
          ...state.module19,
          rewards: {
            ...state.module19.rewards,
            MonkeyCapuchin: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE19_SET_REWARD62': {
      return {
        ...state,
        module19: {
          ...state.module19,
          rewards: {
            ...state.module19.rewards,
            MonkeyGorilla: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE19_SET_REWARD62_POSITION': {
      return {
        ...state,
        module19: {
          ...state.module19,
          rewards: {
            ...state.module19.rewards,
            MonkeyGorilla: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE19_SET_REWARD71': {
      return {
        ...state,
        module19: {
          ...state.module19,
          rewards: {
            ...state.module19.rewards,
            SnakeOrange: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE19_SET_REWARD71_POSITION': {
      return {
        ...state,
        module19: {
          ...state.module19,
          rewards: {
            ...state.module19.rewards,
            SnakeOrange: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE19_SET_REWARD72': {
      return {
        ...state,
        module19: {
          ...state.module19,
          rewards: {
            ...state.module19.rewards,
            SnakeGreen: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE19_SET_REWARD72_POSITION': {
      return {
        ...state,
        module19: {
          ...state.module19,
          rewards: {
            ...state.module19.rewards,
            SnakeGreen: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE19_SET_REWARD11': {
      return {
        ...state,
        module19: {
          ...state.module19,
          rewards: {
            ...state.module19.rewards,
            StandIceCreamBlue: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE19_SET_REWARD11_POSITION': {
      return {
        ...state,
        module19: {
          ...state.module19,
          rewards: {
            ...state.module19.rewards,
            StandIceCreamBlue: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE19_SET_REWARD12': {
      return {
        ...state,
        module19: {
          ...state.module19,
          rewards: {
            ...state.module19.rewards,
            StandIceCreamGreen: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE19_SET_REWARD12_POSITION': {
      return {
        ...state,
        module19: {
          ...state.module19,
          rewards: {
            ...state.module19.rewards,
            StandIceCreamGreen: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE19_SET_PRIZE1': {
      return {
        ...state,
        module19: {
          ...state.module19,
          rewards: {
            ...state.module19.rewards,
            MonkeySafari: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE19_SET_PRIZE1_POSITION': {
      return {
        ...state,
        module19: {
          ...state.module19,
          rewards: {
            ...state.module19.rewards,
            MonkeySafari: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE19_SET_PRIZE2': {
      return {
        ...state,
        module19: {
          ...state.module19,
          rewards: {
            ...state.module19.rewards,
            MonkeySunglasses: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE19_SET_PRIZE2_POSITION': {
      return {
        ...state,
        module19: {
          ...state.module19,
          rewards: {
            ...state.module19.rewards,
            MonkeySunglasses: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE19_SET_DAY_UNLOCK1': {
      return {
        ...state,
        module19: {
          ...state.module19,
          unlockedDays: {
            ...state.module19.unlockedDays,
            day1: action.payload,
          },
        },
      };
    }
    case 'MODULE19_SET_DAY_UNLOCK2': {
      return {
        ...state,
        module19: {
          ...state.module19,
          unlockedDays: {
            ...state.module19.unlockedDays,
            day2: action.payload,
          },
        },
      };
    }
    case 'MODULE19_SET_DAY_UNLOCK3': {
      return {
        ...state,
        module19: {
          ...state.module19,
          unlockedDays: {
            ...state.module19.unlockedDays,
            day3: action.payload,
          },
        },
      };
    }
    case 'MODULE19_SET_DAY_UNLOCK4': {
      return {
        ...state,
        module19: {
          ...state.module19,
          unlockedDays: {
            ...state.module19.unlockedDays,
            day4: action.payload,
          },
        },
      };
    }
    case 'MODULE19_SET_DAY_UNLOCK5': {
      return {
        ...state,
        module19: {
          ...state.module19,
          unlockedDays: {
            ...state.module19.unlockedDays,
            day5: action.payload,
          },
        },
      };
    }
    case 'MODULE19_SET_DAY_UNLOCK6': {
      return {
        ...state,
        module19: {
          ...state.module19,
          unlockedDays: {
            ...state.module19.unlockedDays,
            day6: action.payload,
          },
        },
      };
    }
    case 'MODULE19_SET_DAY_UNLOCK7': {
      return {
        ...state,
        module19: {
          ...state.module19,
          unlockedDays: {
            ...state.module19.unlockedDays,
            day7: action.payload,
          },
        },
      };
    }
    case 'MODULE19_SET_DAY_UNLOCK8': {
      return {
        ...state,
        module19: {
          ...state.module19,
          unlockedDays: {
            ...state.module19.unlockedDays,
            day8: action.payload,
          },
        },
      };
    }

    default:
      return state;
  }
};
export default Module19Reducer;
